import { generators } from '@playcastdotio/Messaging';
import { ipcSend } from '../../../../api/messaging/protocols/ipc';
import type { PlaycastGamepadXInput, XInput } from '@playcastdotio/CoreTypes';

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function toXInputButtonMask(button: string): number {
  switch (button) {
    case 'A': return 0x1000;
    case 'B': return 0x2000;
    case 'X': return 0x4000;
    case 'Y': return 0x8000;
    case 'DUP': return 0x0001;
    case 'DDOWN': return 0x0002;
    case 'DLEFT': return 0x0004;
    case 'DRIGHT': return 0x0008;
    case 'START': return 0x0010;
    case 'BACK': return 0x0020;
    case 'LS': return 0x0040;
    case 'RS': return 0x0080;
    case 'LB': return 0x0100;
    case 'RB': return 0x0200;
    case 'GUIDE': return 0x0400;
    default: return 0;
  }
}

function neutralXInput(): XInput {
  return {
    wButtons: 0,
    bLeftTrigger: 0,
    bRightTrigger: 0,
    sThumbLX: 0,
    sThumbLY: 0,
    sThumbRX: 0,
    sThumbRY: 0,
  };
}

function applyButtonToXInput(button: string, x: XInput): XInput {
  const mask = toXInputButtonMask(button);
  if (mask) return { ...x, wButtons: x.wButtons | mask };

  switch (button) {
    case 'LT': return { ...x, bLeftTrigger: 255 };
    case 'RT': return { ...x, bRightTrigger: 255 };
    default: return x;
  }
}

export class MacroGamepadEmitter {
  public async sendGamepadTap(button: string, hold: number): Promise<void> {
    const downX = applyButtonToXInput(button, neutralXInput());

    const base: Omit<PlaycastGamepadXInput, 'xInput'> = {
      gamepadId: 0,
      playerCoordinates: {
        origin: 'bottomLeft',
        dimensions: { x: 0, y: 0 },
        display: { x: 0, y: 0 },
      },
    };

    ipcSend(generators.gamepad.setXInput('host', { ...base, xInput: downX }));
    await delay(hold);

    ipcSend(generators.gamepad.setXInput('host', { ...base, xInput: neutralXInput() }));
    await delay(20);
  }
}
